var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "settings-container"
  }, [_c('substrate-mount', {
    attrs: {
      "flat": ""
    }
  }, [_vm._l(_vm.paymentOptions, function (paymentOption) {
    return [paymentOption.name === 'QIWI' ? _c('setting-receiving-payments-qiwi', {
      key: paymentOption.name,
      attrs: {
        "option": paymentOption
      },
      on: {
        "blocked": _vm.onClickToDisabledOption,
        "unavailable": function unavailable($event) {
          return _vm.onClickToUnavailableOption(paymentOption.name);
        }
      }
    }) : paymentOption.name === 'YOOMONEY' ? _c('setting-receiving-payments-yoo-money', {
      key: paymentOption.name,
      attrs: {
        "option": paymentOption
      },
      on: {
        "blocked": _vm.onClickToDisabledOption,
        "unavailable": function unavailable($event) {
          return _vm.onClickToUnavailableOption(paymentOption.name);
        }
      }
    }) : _c('toggle-panel', {
      key: paymentOption.name,
      attrs: {
        "title": paymentOption.displayName,
        "disabled": paymentOption.blocked
      },
      on: {
        "click": function click($event) {
          return _vm.handleToggleOption(paymentOption);
        }
      },
      model: {
        value: paymentOption.enabled,
        callback: function callback($$v) {
          _vm.$set(paymentOption, "enabled", $$v);
        },
        expression: "paymentOption.enabled"
      }
    }, [_c(_vm.getIconComponent(paymentOption.name), {
      tag: "component",
      attrs: {
        "slot": "icon"
      },
      slot: "icon"
    })], 1)];
  })], 2), _c('cs-dialog', {
    model: {
      value: _vm.isShownAccessInformation,
      callback: function callback($$v) {
        _vm.isShownAccessInformation = $$v;
      },
      expression: "isShownAccessInformation"
    }
  }, [_c('dialog-default-layout', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.dialog.title)
    },
    slot: "title"
  }), _vm.dialog.message ? _c('p', {
    attrs: {
      "slot": "content"
    },
    domProps: {
      "textContent": _vm._s(_vm.dialog.message)
    },
    slot: "content"
  }) : _vm._e(), _c('div', {
    staticClass: "dialog-footer-container",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('cs-button', {
    attrs: {
      "width": "100%"
    },
    on: {
      "click": _vm.onCloseAccessInformation
    }
  }, [_vm._v(" " + _vm._s(_vm.dialog.submit) + " ")])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }